module.exports = __webpack_public_path__ + "static/media/bollywood_kids.a54de012.jpg";